import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { isAuthenticated } from '~/auth/slices/auth.slice'
import appConfig from '~/config/app'
import useCurrentFamily from '~/familyAccount/hooks/useCurrentFamily'

import { useAppSelector } from '~/redux/hooks'
import { selectPreviewSite } from '~/redux/slices/ui'
import ROUTES from '~/shared/constants/routes.const'

function usePreviewSite(): void {
  const authenticated = useAppSelector(isAuthenticated)
  const router = useRouter()
  const { hasLicense, isFamilyAdmin } = useCurrentFamily()

  const previewSite = useAppSelector(selectPreviewSite)

  useEffect(() => {
    if (authenticated || previewSite) {
      // /family/switch-profile 404s in the school platform — fall through to the dashboard.
      if (!hasLicense && isFamilyAdmin && !appConfig.isSchoolPlatform) {
        router.replace(ROUTES.FAMILY_SWITCH_PROFILE)

        return
      }
      router.replace(ROUTES.DASHBOARD)
    }
  }, [router, authenticated, previewSite, hasLicense, isFamilyAdmin])
}

export default usePreviewSite
